module.exports = __webpack_public_path__ + "245592e42c9269ca55efe691ec118e68.png";